
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shows",
      function () {
        return require("private-next-pages/shows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shows"])
      });
    }
  